// FormSteps.js
import React, { useRef,useEffect, useState } from 'react';
import { Button, Card, Col, Container, Form, InputGroup, Row , OverlayTrigger,Popover, Tooltip} from 'react-bootstrap';
import loginbg from "../../../../assets/images/Weighing.jpg";
import { useDispatch, useSelector } from 'react-redux';
import { GetAllGoalsServices, GetAllPreferencesServices } from '../../../../core/store/thunks';
import { createSelector } from '@reduxjs/toolkit';
import { Eye, EyeOff } from 'lucide-react';

const RenderStepContent = (currentStep, formData , values, setFieldValue, validation, selectedGoal, setSelectedGoal) => {
 
  const [selectedOption, setSelectedOption] = useState(null);

  const [useMetric, setUseMetric] = useState(false);
  const [kilometer, sekilometer] = useState(false);

  //const [selectedGoal, setSelectedGoal] = useState(null);
  const [selectedActivity, setSelectedActivity] = useState(null);
  const recommendationInputRef = useRef(null);
  const preferenceInputRef = useRef(null);
const intoleranceInputRef = useRef(null);

  const goals = [
    {name:"Perdre du poids",id:'LOSE'},
    {name:"Maintenir poids",id:'MAINTAIN '},
    {name:"Prendre du poids",id:'GAIN'},
    { name: "Me muscler",id:"MUSCLE"},
    { name: "Secher",id:"CUT"},
   
  ];

  const methodes = [
    {name:"DIET",id:'DIET'},
    {name:"EXERCISE",id:'EXERCISE '},
    {name:"COMBINATION",id:'COMBINATION'},
   
   
  ];

  const activities = [
    { 
      id: "SEDENTARY", 
      name: "Sedentary", 
      description: "You have a desk job and do little to no physical activity during the day. You may take short walks but do not engage in regular exercise."
    },
    { 
      id: "MODERATE", 
      name: "Moderate", 
      description: "You engage in light physical activity such as walking or casual sports 1-3 times a week. Your job may require occasional movement."
    },
    { 
      id: "ACTIVE", 
      name: "Active", 
      description: "You perform moderate to intense exercise 3-5 times a week. Your job may involve frequent movement, such as standing or lifting."
    },
    { 
      id: "VERY_ACTIVE", 
      name: "Very Active", 
      description: "You engage in intense workouts almost daily or have a physically demanding job (e.g., construction worker, athlete, or courier)."
    }
  ];
  
    const [showInput, setShowInput] = useState(false);

    const [showInputIntolerances, setShowInputIntolerances] = useState(false);
  

    const [recommendations, setRecommendations] = useState([]);
const [newRecommendation, setNewRecommendation] = useState("");
const [showInputRecommandation, setShowInputRecommandation] = useState(false);
// Fonction pour ajouter une nouvelle recommandation
const addRecommendation = () => {
  if (newRecommendation.trim() !== "") {
    const updatedRecommendations = [...recommendations, newRecommendation];
    setRecommendations(updatedRecommendations);
    setNewRecommendation(""); // Réinitialiser le champ de saisie
    setShowInput(false); // Cacher le champ d'ajout après soumission

    // Appel de la fonction handleRecommandation avec le tableau mis à jour
    handleRecommandation(updatedRecommendations);
  }
};

// Fonction pour supprimer une recommandation
const removeRecommendation = (index) => {
  setRecommendations((prevRecommendations) => 
    prevRecommendations.filter((_, i) => i !== index)
  );
};
    
    useEffect(() => {
      if (showInput && preferenceInputRef.current) {
        preferenceInputRef.current.focus();
      }
    }, [showInput]);
    
    // Effet pour focus l'input des intolérances
    useEffect(() => {
      if (showInputIntolerances && intoleranceInputRef.current) {
        intoleranceInputRef.current.focus();
      }
    }, [showInputIntolerances]);
  
    useEffect(() => {
      if (showInputRecommandation && recommendationInputRef.current) {
        recommendationInputRef.current.focus();
      }
    }, [showInputRecommandation]);

  // Sélecteur pour l'état des objectifs
const selectGoalsState = (state) => state;


const selectGoalsData = createSelector(
  selectGoalsState,
  (state) => ({
    products: state.Account.goals,
    loading: state.Account.loading,
    error: state.Account.error,
  })
);
const dispatch = useDispatch()

useEffect(() => {
  dispatch(GetAllGoalsServices());

 // dispatch(GetAllPreferencesServices());
 
}, [dispatch]);


const { products, error, loading } = useSelector(selectGoalsData);

  const selectGoal = (goal) => {
    setSelectedGoal(goal);
    formData('su_userGoalDto.weightGoalId', goal);
  };

  const handleSelect = (value) => {
    console.log(value)
    setSelectedOption(value);
    formData('su_userGoalDto.weightGoal', value);
  };

  const handleActivityLevel = (value) => {
    setSelectedActivity(value);
    formData('su_activityLevel', value);
  };

  const handlePreference = (value) => {
    formData('su_preferences', value);
    console.log("Données envoyées RENDER :", formData);
  };
  
  const handleRecommandation = (value) => {
  formData("su_recommandations", value);
  console.log("Données envoyées RENDER su_recommandations :", value);
};

  const [showPassword, setShowPassword] = useState(false);
  switch (currentStep) {

    //userName
    case 1:
      return (
        <>
          <Card>
            <Card.Header as="h3" className="text-center fw-bold">How should we call you?</Card.Header>
            <Card.Body>
              <Form.Group className="mb-3">

                <Form.Control placeholder='Firstname' type="text" name="firstname" value={values.firstname ?? ""} onChange={validation.handleChange} />
              </Form.Group>
              <Form.Group className="mb-3">

                <Form.Control placeholder='Lastnane' type="text" name="lastname" value={values.lastname ?? ""} onChange={validation.handleChange} />
              </Form.Group>


            </Card.Body>
          </Card>
        </>
      );


   
    case 2:
      return (
        <Container className="mt-4">
        <Card>
          <Card.Body>
            <h2 className="text-center mb-3">Thank you! Now let's focus on your goals.</h2>
            <p className="text-center mb-4">
            Select the element that is most important to you.
            </p>
            <p style={{color:'yellowgreen'}}  > Field required <span style={{fontSize:'30px', color: 'red'}}>*</span></p>
            {products &&
             ( products.map((goal, index) => (
              <Button
                key={index}
                variant={selectedGoal === goal.id ? "primary" : "outline-primary"}
                className="w-100 mb-2"
                onClick={() => selectGoal(goal.id)}
              >
                {goal.name || "Nom indisponible"}
              </Button>
            ))
            )}
          
          </Card.Body>
        </Card>
      </Container>
      );


    //niveau d'activité SEDENTARY, MODERATE, ACTIVE, VERY_ACTIVE 
    case 3: 
    return (
      <Container className="mt-4">
        <Card>
          <Card.Body>
            <h2 className="text-center mb-3">What is your basic activity level?</h2>
  
            {activities.map((activity, index) => (
           <OverlayTrigger
           key={index}
           placement="top"
           overlay={
             <Popover 
               id={`popover-${activity.id}`} 
               style={{
                 maxWidth: '600px',
                 backgroundColor: 'whitesmoke', /* Couleur de fond noire */
                 borderRadius: '8px', /* Coins arrondis */
                 boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)', /* Ombre portée douce */
                 color: '#fff', /* Texte en blanc */
                 padding: '10px', /* Espacement interne */
               }}
             >
               <Popover.Body
                 style={{
                   whiteSpace: 'normal', /* Permet au texte de passer à la ligne */
                   overflow: 'hidden',
                   lineHeight: '1.5', /* Espacement des lignes */
                   fontSize: '16px', /* Taille du texte */
                   fontWeight: 'bold', /* Gras */
                   color: '#111', /* Texte en blanc */
                 }}
               >
                 {activity.description}
               </Popover.Body>
             </Popover>
           }
         >
           <Button
             variant={selectedActivity === activity.id ? "primary" : "outline-primary"}
             className="w-100 mb-2"
             onClick={() => handleActivityLevel(activity.id)}
           >
             {activity.name}
           </Button>
         </OverlayTrigger>
           
           
            ))}
  
          </Card.Body>
        </Card>
      </Container>
    );

  

      // case 4:
      //   return (
      //     <Container className="mt-2">
      //     <Card>
      //       <Card.Body>
      //         {/* Section Recommandations */}
      //         <h2 className="text-center mb-3">Do you have medical recommendations?</h2>
      //         <p style={{color: 'yellowgreen', fontWeight:'bold', fontFamily:'serif', fontSize:'18px'}} >This field is optional</p>
      
      //         {/* Affichage des recommandations ajoutées */}
      //         {recommendations.map((rec, index) => (
      //           <div key={index} className="d-flex align-items-center mb-2">
      //             <Button variant="outline-primary" className="w-100">
      //               {rec}
      //             </Button>
      //             <Button
      //               style={{
      //                 marginLeft: "2px",
      //                 height: "55px",
      //                 width: "60px",
      //                 display: "flex",
      //                 alignItems: "center",
      //                 justifyContent: "center",
      //               }}
      //               variant="danger"
      //               className="ms-2"
      //               onClick={() => removeRecommendation(index)}
      //             >
      //               <span size={60} color="#fff">x</span>
      //             </Button>
      //           </div>
      //         ))}
      
      //         {/* Section pour ajouter une nouvelle recommandation */}
      //         {showInputRecommandation ? (
      //           <div className="mt-3">
      //             <Form.Control
      //               type="text"
      //               value={newRecommendation ?? ""}
      //               onChange={(e) => setNewRecommendation(e.target.value)}
      //               placeholder="Enter your recommendation"
      //               ref={recommendationInputRef}
      //             />
                
      //             <Button className="mt-2" variant="success" onClick={addRecommendation}>
      //               Submit
      //             </Button>
      //           </div>
      //         ) : (
      //           <Button className="mt-3" variant="primary" onClick={() => setShowInputRecommandation(true)}>
      //             Add Recommendation
      //           </Button>
      //         )}
      //       </Card.Body>
      //     </Card>
      //   </Container>
      //   );
      

    //gender
    case 4:
      return (
        <>
          <Card>
            <Card.Header as="h3" className="text-center fw-bold">Please select your gender so we can calculate your calorie needs.</Card.Header>
            <Card.Body>
              <Container className="mt-5">

                <Form.Group className="mb-4">

                  <div>
                    <Form.Check
                      type="radio"
                      label="Man"
                      name="gender"
                      id="sexe-homme"
                      value="MALE"
                      checked={values.gender === "MALE"}

                      onChange={setFieldValue}
                      onBlur={validation.handleBlur}
                    />
                    <Form.Check
                      type="radio"
                      label="Woman"
                      name="gender"
                      id="sexe-femme"
                      value='FEMALE'
                      checked={values.gender === "FEMALE"}
                      onChange={setFieldValue}
                      onBlur={validation.handleBlur}
                    />
                  </div>

                </Form.Group>

                <Form.Group className="mb-4">
                  <Form.Label as="h4">What is your date of birth?</Form.Label>
                  <Form.Control
                    name='dateOfBirth'
                    type="date"
                    onChange={setFieldValue}
                    onBlur={validation.handleBlur}
                    value={values.dateOfBirth || ""}
                  />
                </Form.Group>



                <p className="text-muted">
                We use this information to calculate the calorie goal that suits you.
                </p>

              </Container>


            </Card.Body>
          </Card>
        </>
      );


    //TAILLE ET POIDS
    case 5:
      return (
        <>
          <Card>
            <Container className="mt-4">

              <h2>How tall are you?
</h2>
              <Row className="mb-3">
                <Col>
                  <Form.Group>
                    <Form.Control
                      type="number"
                      name='su_height'
                      placeholder={useMetric ? " Height(cm)" : "Height (cm)"}
                      value={values.su_height ?? ""}
                      onChange={validation.handleChange}
                    />
                  </Form.Group>
                </Col>
          
              </Row>
         

              <h2 className="mt-4">How much do you weigh?
</h2>
              <Form.Text className="text-muted">
              You can provide an estimate and update this information later.

              </Form.Text>
              <Row className="mt-2 mb-3">
                <Col>
                  <Form.Group>
                    <Form.Control
                      type="number"
                      name='su_initialWeight'
                      placeholder={!kilometer ? "Current weight (kg)" : "Current weight (kg)"}
                      value={values.su_initialWeight ?? ""}
                      onChange={validation.handleChange}
                    />
                  </Form.Group>
                </Col>
              </Row>
            

            </Container>
          </Card>
        </>
      );
    // register
    case 6:
      return (
        <>
          <Container className="mt-5">
            <Card>
              <Card.Body>
                <h2 className="text-center mb-4">You're almost there! Create your account.</h2>

                <Form.Group className="mb-3">
                  <Form.Control
                    type="email"
                    name='email'
                    placeholder="Email address"
                    value={formData.email }
                    onChange={validation.handleChange}
                    required
                  />
                </Form.Group>

                <Form.Group className="mb-3 position-relative">
                  <InputGroup>
                    <Form.Control
                      type={showPassword ? "text" : "password"}
                      name='password'
                      placeholder="Créer un mot de passe"
                      value={formData.password }
                      onChange={validation.handleChange}
                      required
                    />
                    <span 
                      className="input-group-text" 
                      style={{ cursor: 'pointer' }}
                      onClick={() => setShowPassword(!showPassword)}
                    >
                      {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                    </span>
                  </InputGroup>

                </Form.Group>

                <Form.Text className="text-muted mb-3 d-block">
                Must be at least 4 characters long, with no spaces.
                </Form.Text>



                <Form.Group className="mb-3">
                  <Form.Check
                    type="checkbox"
                    id="acceptTerms"
                    label={
                      <span>
                      I accept the <a href="#" className="text-primary"> Terms and Conditions and the</a>{' '}
                        <a href="#" className="text-primary">Privacy Policy</a> of WELLBE.
                      </span>
                    }
                    
                  />
                </Form.Group>

                {/* <Button variant="primary" type="submit" className="w-100">
                  Créer un compte
                </Button> */}

              </Card.Body>
            </Card>
          </Container>
        </>
      );
   

      case 7:
        return (
          <>
        <Container className="mt-4">
      <Card>
        <Card.Body>
          <h2 className="text-center mb-3">Thank you, PICK 3! Now let's focus on your goals.</h2>
          <p className="text-center mb-4">
          Select the element that is most important to you.
          </p>
          {goals.map((goal, index) => (
            <Button
              key={index}
              variant={selectedGoal === goal.id ? "primary" : "outline-primary"}
              className="w-100 mb-2"
              onClick={() => selectGoal(goal.id)}
            >
              {goal.name}
            </Button>
          ))}
          <div className="d-flex justify-content-between mt-4">
            <Button variant="outline-primary">Previous</Button>
            <Button 
              variant="primary" 
              disabled={!selectedGoal}
            >
              Next
            </Button>
          </div>
        </Card.Body>
      </Card>
    </Container>
  
          </>
        );


      case 31:
      return (
        <>
          <Card>
            <Card.Header as="h3" className="text-center fw-bold">What is your basic activity level?</Card.Header>
            <Card.Body>
              <Container className="d-flex flex-column align-items-center mt-5">
                <Row className={`mb-3 `}
                  onClick={() => handleSelect('seden')}
                  style={{ cursor: 'pointer' }}>
                  <Col>
                    <Card className={`p-2outline-primary border border-primary ${selectedOption === 'seden' ? 'bg-primary ' : ''}`} style={{ width: '22rem' }}>
                      <Row className="align-items-center">

                        <Card.Body>
                          <Card.Title>Sedentaire</Card.Title>
                          <Card.Subtitle>You spend most of the day sitting</Card.Subtitle>
                        </Card.Body>




                      </Row>
                    </Card>
                  </Col>
                </Row>
                <Row className={`mb-3 `}
                  onClick={() => handleSelect('moderer')}
                  style={{ cursor: 'pointer' }}>
                  <Col>
                    <Card className={`p-2outline-primary border border-primary ${selectedOption === 'moderer' ? 'bg-primary ' : ''}`} style={{ width: '22rem' }}>
                      <Row className="align-items-center">

                        <Card.Body>
                          <Card.Title>Moderement actif</Card.Title>
                          <Card.Subtitle>You spend most of the day standing</Card.Subtitle>
                        </Card.Body>




                      </Row>
                    </Card>
                  </Col>
                </Row>
                <Row className={`mb-3 `}
                  onClick={() => handleSelect('actif')}
                  style={{ cursor: 'pointer' }}>
                  <Col>
                    <Card className={`p-2outline-primary border border-primary ${selectedOption === 'actif' ? 'bg-primary ' : ''}`} style={{ width: '22rem' }}>
                      <Row className="align-items-center">

                        <Card.Body>
                          <Card.Title>Actif </Card.Title>
                          <Card.Subtitle>You spend a good part of the day doing physical activities</Card.Subtitle>
                        </Card.Body>




                      </Row>
                    </Card>
                  </Col>
                </Row>
                <Row className={`mb-3 `}
                  onClick={() => handleSelect('tres')}
                  style={{ cursor: 'pointer' }}>
                  <Col>
                    <Card className={`p-2outline-primary border border-primary ${selectedOption === 'tres' ? 'bg-primary ' : ''}`} style={{ width: '22rem' }}>
                      <Row className="align-items-center">

                        <Card.Body>
                          <Card.Title>Tres actif </Card.Title>
                          <Card.Subtitle>You spend a good part of the day doing very physical activities</Card.Subtitle>
                        </Card.Body>




                      </Row>
                    </Card>
                  </Col>
                </Row>


              </Container>
            </Card.Body>
          </Card>
        </>
      );







    //TAILLE
    case 110:
      return (
        <>
          <Card>
            <Card.Header as="h3" className="text-center fw-bold">What is your height?</Card.Header>
            <Card.Body>
              <Form.Group className="mb-3">
                <InputGroup>
                  <Form.Control
                    type="number"
                    name="poids"
                    value={formData.poids}
                    onChange={validation.handleChange}
                    placeholder="Enter your height"
                    min="0"
                    max='50'
                    step="0.1"
                  />
                  <InputGroup.Text>kg</InputGroup.Text>
                </InputGroup>
              </Form.Group>
            </Card.Body>
          </Card>
        </>
      );
    case 50:
      return (
        <>
          <Card>
            <Card.Header as="h3" className="text-center fw-bold">What is your goal?</Card.Header>
            <Card.Body>
              <Container className="d-flex flex-column align-items-center mt-5">
                <Row className={`mb-3 `}
                  onClick={() => handleSelect('perdre')}
                  style={{ cursor: 'pointer' }}>
                  <Col>
                    <Card className={`p-2outline-primary ${selectedOption === 'perdre' ? 'bg-primary ' : ''}`} style={{ width: '22rem' }}>
                      <Row className="align-items-center">
                        <Col>
                          <Card.Body>
                            <Card.Title>Lost heigth</Card.Title>
                          </Card.Body>
                        </Col>
                        <Col xs="auto">
                          <img width={100}
                            className='me-4'
                            src={loginbg}
                            alt="Sculpter ma silhouette"
                            style={{ borderRadius: '10%' }}
                          />
                        </Col>

                      </Row>
                    </Card>
                  </Col>
                </Row>

                <Row className={`mb-3 `}
                  onClick={() => handleSelect('gagner')}
                  style={{ cursor: 'pointer' }}>
                  <Col>
                    <Card className={`p-2outline-primary ${selectedOption === 'gagner' ? 'bg-primary ' : ''}`} style={{ width: '22rem' }}>
                      <Row className="align-items-center">
                        <Col>
                          <Card.Body>
                            <Card.Title>Gain weight</Card.Title>
                          </Card.Body>
                        </Col>
                        <Col xs="auto">
                          <img width={100}
                            className='me-4'
                            src={loginbg}
                            alt="Sculpter ma silhouette"
                            style={{ borderRadius: '10%' }}
                          />
                        </Col>

                      </Row>
                    </Card>
                  </Col>
                </Row>

              </Container>
            </Card.Body>
          </Card>
        </>
      );

    case 70:
      return (
        <>
          <Form.Group className="mb-3">
            <Form.Label>Profession</Form.Label>
            <Form.Control type="text" name="profession" value={formData.profession} onChange={validation.handleChange} />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Loisirs</Form.Label>
            <Form.Control type="text" name="loisirs" value={formData.loisirs} onChange={validation.handleChange} />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Sport préféré</Form.Label>
            <Form.Control type="text" name="sportPrefere" value={formData.sportPrefere} onChange={validation.handleChange} />
          </Form.Group>
        </>
      );
   
    case 9:
      return (
        <>
          <Card>
            <Card.Header as="h3" className="text-center fw-bold">what is your heigth  ?</Card.Header>
            <Card.Body>
              <Form.Group className="mb-3">
                <InputGroup>
                  <Form.Control
                    type="number"
                    name="poids"
                    value={formData.poids}
                    onChange={validation.handleChange}
                    placeholder="Enter your weight"
                    min="0"
                    max='50'
                    step="0.1"
                  />
                  <InputGroup.Text>kg</InputGroup.Text>
                </InputGroup>
              </Form.Group>
            </Card.Body>
          </Card>
        </>
      );
    case 10:
      return (
        <>
          <Form.Group className="mb-3">
            <Form.Label>Profession</Form.Label>
            <Form.Control type="text" name="profession" value={formData.profession} onChange={validation.handleChange} />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Loisirs</Form.Label>
            <Form.Control type="text" name="loisirs" value={formData.loisirs} onChange={validation.handleChange} />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Sport préféré</Form.Label>
            <Form.Control type="text" name="sportPrefere" value={formData.sportPrefere} onChange={validation.handleChange} />
          </Form.Group>
        </>
      );
    case 11:
      return (
        <>
          <Form.Group className="mb-3">
            <Form.Label>Profession</Form.Label>
            <Form.Control type="text" name="profession" value={formData.profession} onChange={validation.handleChange} />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Loisirs</Form.Label>
            <Form.Control type="text" name="loisirs" value={formData.loisirs} onChange={validation.handleChange} />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Sport préféré</Form.Label>
            <Form.Control type="text" name="sportPrefere" value={formData.sportPrefere} />
          </Form.Group>
        </>
      );
    default:
      return null;
  }
}
;

export default RenderStepContent;